<template>
  <router-view />
</template>

<script>
import { useAuthStore } from './store/auth'

export default {
  name: 'App',
  setup() {
    const authStore = useAuthStore()
    // 身份由路由守卫向本站 BFF 确认。
    authStore.initializeAuth()
  }
}
</script>

<style>
@import './assets/css/main.css';

#app {
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  overflow: hidden;
}
</style>
